import React, { useState, useEffect, useCallback } from "react";
import Helmet from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FadeLoader from "react-spinners/FadeLoader";
import { USER } from "common/viewContent";
import * as Path from "routes/Path/index";
import {
  getUsers,
  updateUser,
  AddUser,
  updateUserStatus,
  exportUsersList,
  deleteUserApi,
} from "store/actions";
import { toast } from "react-toastify";
import Table from "components/Table";
import Columns from "./Columns";
import AddUserModal from "components/Modals/AddUser";
import FormikForm from "components/shared/FormikForm";
import DateRangeFilter from "components/DateRangePicker/DateRangePicker";
import moment from "moment";
import slice from "store/user/slice";
import AddSubAmin from "components/Modals/AddUpdateSubAmin";
import { getCoinList, reloadCoinList } from "store/coinList/actions";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search using coin name",
  },
];
const initialValuesForFilter = {
  search: "",
};

const List = () => {
  const dispatch = useDispatch();
  const [showAdd, setShowAdd] = useState(false);
  const { coinlist, loading, totalCount } = useSelector(
    (state) => state.CoinList,
  );
  const [columns, setcolumns] = useState([{ dataField: "", text: "" }]);

  const [showPicker, setShowPicker] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 20,
    order: -1,
    // orderBy: "createdAt",
    search: "",
    // status: "",
    // startDate: null,
    // endDate: null,
    // role: "SUBADMIN",
  });
  const [rowData, setRowData] = useState(null);

  useEffect(() => {
    getApiData(filter);
    setcolumns(Columns({ handleUserStatus, handleEditHandler, deleteHandler }));
  }, [filter]);

  const deleteHandler = (id) => {
    try {
      const userConfirmed = window.confirm(
        "Are you sure, you want to delete this sub admin?",
      );
      if (userConfirmed) {
        const callback = (err, res) => {
          if (err) {
          } else {
            getApiData(filter);
          }
        };

        dispatch(
          deleteUserApi({
            data: { _id: id },
            callback,
          }),
        );
      }
    } catch (error) {
      console.error(error, "<===err");
    }
  };
  async function getApiData(query) {
    try {
      dispatch(getCoinList({ data: query }));
    } catch (error) {}
  }

  const handleUserStatus = (id, status) => {
    try {
      const callback = (err, res) => {
        if (err) return;

        getApiData(filter);
      };

      dispatch(
        updateUserStatus({
          data: { _id: id, status: status },
          callback,
        }),
      );
    } catch (error) {
      console.error(error, "<===err");
    }
  };

  const handleReload = async () => {
    try {
      await dispatch(reloadCoinList({})).unwrap();
      getApiData(filter);
    } catch (error) {
      console.error(error);
    }
  };

  const handleFilterForm = (info) => {
    setFilter({
      ...filter,
      page: 1,
      limit: 20,
      order: -1,
      // orderBy: "date_created_utc",
      search: info.search,
      // status: info.status,
    });
  };
  const navigate = useNavigate();
  const handleEditHandler = (info) => {
    setRowData(info);
    setShowAdd(true);
    // navigate(`/admin/subadmin/view/${info?._id}`);
  };
  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");
    setFilter((prevFilter) => ({
      ...prevFilter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    }));
    setShowPicker(false);
  };

  return (
    <>
      {loading && (
        <div className="main-loader">
          <FadeLoader size={1000} />
        </div>
      )}
      {showAdd && (
        <AddSubAmin
          rowData={rowData}
          show={true}
          handleClose={() => {
            setShowAdd(false);
            setRowData(null);
          }}
          handleConfirm={() => {
            getApiData(filter);
            setRowData(null);
          }}
        />
      )}
      <Helmet title={"Coin List"} />

      <section className="section">
        <div className="section-header">
          <h1>Coin List</h1>
          <button
            onClick={() => handleReload()}
            className="btn btn-primary btn-lg "
          >
            Reload Coin List
          </button>
          {/* <div className="section-header-breadcrumb">
            <div className="breadcrumb-item active">
              <Link to={"/admin/" + Path.dashboard}>Dashboard</Link>
            </div>
            <div className="breadcrumb-item">{USER.CURRENT_MODULE} </div>
          </div> */}
        </div>
        <div className="section-body">
          <div className="card">
            <div className="row justify-content-between">
              <div className="col-6">
                <div className="card-header">
                  <h2 className="section-title">Coin Lists</h2>
                </div>
              </div>
              {/* <div className="col-6">
                <div className="card-header d-flex justify-content-end align-items-center">
                  <button
                    className="btn btn-primary"
                    onClick={() => setShowAdd(true)}
                  >
                    Add
                  </button>
                </div>
              </div> */}
              <div className="col-12">
                <div className="card-header">
                  <FormikForm
                    initialValues={initialValuesForFilter}
                    onSubmit={handleFilterForm}
                    loading={loading}
                    inputFields={InputFieldsForSearch}
                    buttonText={"Search"}
                    dateRange={filter}
                    showPicker={showPicker}
                    setShowPicker={setShowPicker}
                    handleSelect={handleSelect}
                  />
                </div>
              </div>
            </div>
          </div>
          {coinlist?.length > 0 && (
            <Table
              data={coinlist}
              columns={columns}
              setFilter={setFilter}
              total={totalCount}
              filter={filter}
              toggleConfirmModal={handleUserStatus}
            />
          )}
          {!loading && coinlist?.user?.length === 0 && (
            <p style={{ textAlign: "center" }}>No coin list Found</p>
          )}
        </div>
      </section>
    </>
  );
};

export default List;
